import React, { useContext, useEffect } from "react"
import { css, keyframes } from "emotion"
import { ConfettiContext } from "./Confetti"

let WavingHand = keyframes`
	from {
		transform: rotate(40deg);
	}
	to {
		transform: rotate(-10deg);
	}
`

let SlideLeft = keyframes`
	0% {
		transform: translate3D(0, 0, 0);
		opactiy: 0.7;
	}
	20% {
		transform: translate3D(-100px, 0, 0);
		opacity: 1;
	}
	80% {
		transform: translate3D(-100px, 0, 0);
		opacity: 1;
	}
	100% {
		transform: translate3D(0, 0, 0);
		opacity: 0;
	}
`

export interface SaysHiProps {
	from: string
	to: string
	currentUsername: string
}

export default function SaysHi(props: SaysHiProps) {
	let { celebrate } = useContext(ConfettiContext)

	useEffect(() => {
		celebrate([
			"👋",
			"👋🏽",
			"👋🏿",
			"👋🏽",
			"😍",
			"👋",
			"🍓",
			"👋🏽",
			"👋🏾",
			"👋",
			"👋",
			"👋🏽",
			"👋",
			"👋🏿",
			"👋",
			"🍓",
			"👋🏾",
			"👋🏽",
			"👋",
			"👋🏿",
			"🍓",
			"😍",
			"😍",
			"🎉",
			"🎉",
		])
	}, [celebrate])

	return (
		<div>
			<div
				className={css`
					animation: ${SlideLeft} 4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
					background: white;
					width: 250px;
					display: flex;
					flex-direction: row;
					align-items: center;
					box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
					position: fixed;
					right: 0em;
					top: 2em;
					z-index: 1000004;
					border-radius: 2px;
					border: 1px solid whitesmoke;
				`}
			>
				<div
					className={css`
						display: flex;
						padding: 1em;
					`}
				>
					<div
						className={css`
							font-size: 2em;
							animation: ${WavingHand} 0.45s linear infinite;
							animation-direction: alternate-reverse;
							margin-right: 10px;
						`}
					>
						👋
					</div>
					<div
						className={css`
							font-family: "SF Pro Text", -apple-system, BlinkMacSystemFont,
								"Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans",
								sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
								"Segoe UI Symbol", "Noto Color Emoji";
							font-size: 14px;
							font-weight: 500;
							line-height: 20px;
							color: #2a3632;
						`}
					>
						{props.to === props.currentUsername
							? `${props.from} says hi`
							: props.from === props.currentUsername
							? `You said hi to ${props.to}`
							: ""}
					</div>
				</div>
			</div>
		</div>
	)
}
